import { IProps as IBlockWrapperProps } from '@/layouts/BlockWrapper/BlockWrapper.interface';
import { IProps as ICardProps } from '@/components/Card/Card.interface';

export interface IDropdown {
  title: string;
  items: { text: string; value: string; selected?: boolean }[];
}

export interface ISearchResultApiResponse {
  items: ICardProps[];
    hasNextPage: boolean;
    gtmDataLayerObject?: string;
}

export interface IProps extends IBlockWrapperProps {
  title?: string;
  columns?: 2 | 3 | 4 | 'two' | 'three' | 'four';
  buttonText?: string;
  categories?: IDropdown;
  tagCategories?: IDropdown;
  hasCategory?: boolean;
  hasSearch?: boolean;
  placeholder?: string;
  noResultMessage?: string;
  noMoreContentMessage: string;
  apiUrl: string;
  cardStyle?: 'grid' | 'list';
}

// Search state and action types
export interface ISearchState {
  openDropdown: boolean; // Whether dropdown is open
  openTagDropdown: boolean; // Whether tag dropdown is open
  page: number;
  selectedCategoryIndex: number;
  selectedTagCategoryIndex: number;
  searchKey: string;
  debouncedSearchKey: string;
}

// Action type constants
export const SEARCH_ACTION_TYPES = {
  SET_OPEN_DROPDOWN: 'SET_OPEN_DROPDOWN',
  SET_OPEN_TAG_DROPDOWN: 'SET_OPEN_TAG_DROPDOWN',
  SET_PAGE: 'SET_PAGE',
  NEXT_PAGE: 'NEXT_PAGE',
  SET_CATEGORY: 'SET_CATEGORY',
  SET_TAG_CATEGORY: 'SET_TAG_CATEGORY',
  SET_SEARCH_KEY: 'SET_SEARCH_KEY',
  SET_DEBOUNCED_SEARCH_KEY: 'SET_DEBOUNCED_SEARCH_KEY',
} as const;

export type ISearchAction =
  | { type: typeof SEARCH_ACTION_TYPES.SET_OPEN_DROPDOWN; payload: boolean }
  | { type: typeof SEARCH_ACTION_TYPES.SET_OPEN_TAG_DROPDOWN; payload: boolean }
  | { type: typeof SEARCH_ACTION_TYPES.SET_PAGE; payload: number }
  | { type: typeof SEARCH_ACTION_TYPES.NEXT_PAGE }
  | { type: typeof SEARCH_ACTION_TYPES.SET_CATEGORY; payload: number }
  | { type: typeof SEARCH_ACTION_TYPES.SET_TAG_CATEGORY; payload: number }
  | { type: typeof SEARCH_ACTION_TYPES.SET_SEARCH_KEY; payload: string }
  | {
      type: typeof SEARCH_ACTION_TYPES.SET_DEBOUNCED_SEARCH_KEY;
      payload: string;
    };
